import React from "react";

import { formatTerminationReason } from "src/agents/base/formatTerminationReason";
import type { TerminationReason } from "src/clients/agent-management";
import { Callout } from "src/design-system/Callout";

type AgentFailedBannerProps = {
  terminationReason: TerminationReason | null;
  terminationMessage: string | null;
};

export const AgentFailedBanner: React.FC<AgentFailedBannerProps> = ({
  terminationReason,
  terminationMessage,
}) => (
  <div className="mt-4 flex-shrink-0">
    <Callout type="error">
      <div className="flex flex-col">
        <span className="font-inter-medium-12px">
          {terminationReason
            ? `Agent failed: ${formatTerminationReason(terminationReason)}`
            : "Agent failed"}
        </span>
        {terminationMessage && (
          <span className="font-inter-normal-12px">{terminationMessage}</span>
        )}
      </div>
    </Callout>
  </div>
);
